<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App"
}

</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

.box {
    // background-color: #f7f7f7;
    height: 400px;
    margin: 10px 0;
    
}

.searchHead {
    display: flex;
    padding: 0 10px 10px;
    justify-content: space-between;
    align-items: center;
    
    > .name {
        font-size: 16px;
        font-weight: bold;
    }
}

.page-content {
    padding: 20px;
}
</style>
